export const MAINTENANCE_MODE = 'PAAR-2945-payex_maintenance_mode';
export const FF_CALCULATE_FOR_RBI = 'PAAR-7275-calculateForRbi';
export const FF_CARD_ELEMENT_FLOW = 'PAAR-6964-CardElementFlow';
export const FF_INDIA_FX_TEST = 'paar-7300-hidenonfxindia';
export const FF_CAPTCHA = 'PAAR-4218-VerifyTokenInBackend';

export const FEATURES = [MAINTENANCE_MODE, FF_CAPTCHA] as const;

export const ENABLE_FEATURE = 'ENABLE_FEATURE';
export const FETCH_FEATURES_REQUEST = 'FETCH_FEATURES_REQUEST';
export const FETCH_FEATURES_SUCCESS = 'FETCH_FEATURES_SUCCESS';
export const FETCH_FEATURES_ERROR = 'FETCH_FEATURES_ERROR';
